import React from 'react';
import { useSelector } from 'react-redux';

import EventRegistrationDetailsCard from '../EventRegistrationDetailsCard';
import EventConfirmationCardContent from './EventConfirmationCardContent';
import {
  selectEventsInCart,
  selectEventsToEdit,
  selectWaitlistEventsInCart,
} from '../redux/selectors';
import EventEditConfirmationFooter from './EventEditConfirmationFooter';

const EventsYouRegisteredFor = () => {
  const aEventsInCart = useSelector(selectEventsInCart);
  const aEditedEventsInCart = useSelector(selectEventsToEdit);
  const aWaitlistEventsInCart = useSelector(selectWaitlistEventsInCart);
  return (
    <>
      {aEventsInCart.length > 0 && (
        <EventRegistrationDetailsCard
          sTitle='Events'
          sCypressId='confirmation-events'
        >
          <EventConfirmationCardContent aEvents={aEventsInCart} />
        </EventRegistrationDetailsCard>
      )}
      {aEditedEventsInCart.length > 0 && (
        <EventRegistrationDetailsCard
          sTitle='Updated Event Registrations'
          sCypressId='confirmation-edited-events'
        >
          <EventConfirmationCardContent aEvents={aEditedEventsInCart} />
          <EventEditConfirmationFooter />
        </EventRegistrationDetailsCard>
      )}
      {aWaitlistEventsInCart.length > 0 && (
        <EventRegistrationDetailsCard
          sTitle='Waitlist Events'
          sCypressId='confirmation-waitlist-events'
        >
          <EventConfirmationCardContent aEvents={aWaitlistEventsInCart} />
        </EventRegistrationDetailsCard>
      )}
    </>
  );
};

export default EventsYouRegisteredFor;
